module.exports = __webpack_public_path__ + "img/image02_sp.b7647ab3.jpg";